
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#EAEDF2"}}),_c('path',{attrs:{"d":"M27.937 8.038a.399.399 0 01.308-.013.367.367 0 01.241.24l.755 2.371h2.36a.378.378 0 01.399.389.462.462 0 01-.157.314l-1.878 1.395.766 2.318a.409.409 0 01-.242.525h-.115a.555.555 0 01-.241-.084l-1.993-1.479-2.004 1.427a.43.43 0 01-.566-.074.262.262 0 01-.073-.325l.755-2.308-1.993-1.384a.398.398 0 01-.126-.556.65.65 0 01.367-.158h2.476l.755-2.37c.035-.1.11-.183.206-.228z","fill":"#586E8C"}}),_c('path',{attrs:{"d":"M23 11H11c-1.688 0-3 1.36-3 3v10.5c0 1.688 1.313 3 3 3h3v3.938c0 .375.234.562.563.562.093 0 .187 0 .328-.094L20.75 27.5h6.75c1.64 0 3-1.313 3-3V17H29v7.5c0 .844-.703 1.5-1.5 1.5h-7.266l-.422.328-4.312 3.235V26H11a1.48 1.48 0 01-1.5-1.5V14c0-.797.656-1.5 1.5-1.5h12V11z","fill":"#586E8C"}}),_c('path',{attrs:{"d":"M12.875 20.75h6.75c.188 0 .375.188.375.375v.75a.37.37 0 01-.375.375h-6.75c-.234 0-.375-.14-.375-.375v-.75a.37.37 0 01.375-.375zM22.625 16.25h-9.75a.37.37 0 00-.375.375v.75c0 .234.14.375.375.375h9.75a.37.37 0 00.375-.375v-.75a.403.403 0 00-.375-.375z","fill":"#586E8C"}})])
          )
        }
      }
    